import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import RolesSelect from '../../../../Components/General/Selects/RolesSelect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getCommuneList, getFuelTypeList, getFuelTypeTypeList, getHoldingList, getProductiveAreaList, getSanitaryVicinityList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import OInput from '../../../../Components/OElements/OInput';
import { addNewFuelType, updateFuelType } from '../../../../slices/thunks';
import { setRequireCloseModal } from '../../../../slices/fuelType/reducer';

const FuelTypeForm = ({
	dataFuelType,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();


	const selectorFuelType = createSelector(
		state => state.FuelType,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorFuelType);

	// validation
	const validation = useFormik({
		enableReinitialize: true, // Permite reestablecer valores iniciales si cambian
		initialValues: {
			name: dataFuelType?.name ?? '',
			code: dataFuelType?.code ?? '',
			emission_factor: dataFuelType?.emission_factor ?? 0,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			code: Yup.string().required('Campo requerido'),
			emission_factor: Yup.string().nullable()
		}),
		onSubmit: values => {
			// Construye el objeto base de la compañía
			const fuel_type = {
				...values,
			};

			if (isEdit) {
				// Actualiza la compañía existente
				dispatch(updateFuelType({ ...fuel_type, _id: dataFuelType._id }));
			} else {
				// Crea una nueva compañía
				dispatch(addNewFuelType(fuel_type));
			}
			dispatch(setRequireCloseModal(false));
			handleToggleModal();
		},
	});


	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={6}>
						<OInput
							name='name'
							label='Nombre'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='code'
							label='Código'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='emission_factor'
							label='Factor de Emisión'
							type='number'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Empresa
					</button>
				</div>
			</div>
		</Form>
	);
};

export default FuelTypeForm;
